import { useMemo, useState } from "react";
import { categoryTabs, guaCards, categoryIntro } from "@/mocks/melonData";

export default function FeedFollow() {
  const [cat, setCat] = useState("all");
  const [kw, setKw] = useState("");

  const filtered = useMemo(() => {
    const word = kw.trim().toLowerCase();
    return guaCards.filter((c) => {
      const matchCat = cat === "all" || c.cat === cat;
      const matchKw =
        !word ||
        [c.target, c.title, c.digest].some((t) => t.toLowerCase().includes(word));
      return matchCat && matchKw;
    });
  }, [cat, kw]);

  return (
    <section id="feed" className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-time-line" /> 追更列表
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">最新跟进</h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            关键字或分类筛选，快速找到那颗你正在跟的瓜，看它的后续、反转与最新进展。
          </p>
        </div>

        <form
          className="w-full max-w-md"
          role="search"
          onSubmit={(e) => e.preventDefault()}
        >
          <label className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-4 py-2.5 focus-within:border-primary-400 transition-colors">
            <i className="ri-search-line text-foreground-400 text-lg" />
            <input
              type="search"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜索瓜子主角或关键词，如：复出"
              aria-label="搜索跟进内容"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
            {kw && (
              <button type="button" aria-label="清空搜索" onClick={() => setKw("")}>
                <i className="ri-close-circle-fill text-foreground-300 hover:text-foreground-500" />
              </button>
            )}
          </label>
        </form>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2">
        {categoryTabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setCat(t.key)}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              cat === t.key
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-7 space-y-4">
        {filtered.length === 0 && (
          <div className="rounded-2xl border border-dashed border-background-300 bg-background-100/50 px-6 py-14 text-center">
            <i className="ri-inbox-2-line text-4xl text-foreground-300" />
            <p className="mt-3 text-sm text-foreground-600">暂未找到匹配的跟进内容，换个关键词试试。</p>
          </div>
        )}

        {filtered.map((c) => {
          const meta = categoryIntro[c.cat as keyof typeof categoryIntro];
          return (
            <article
              key={c.id}
              className="group rounded-2xl border border-background-200/70 bg-background-50 p-5 hover:border-primary-300 hover:shadow-soft transition-all"
            >
              <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${meta.bg} ${meta.color}`}
                    >
                      <i className={meta.icon} />
                      {meta.title}
                    </span>
                    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${c.badgeTone}`}>
                      {c.badge}
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-2.5 py-1 text-[11px] font-medium text-foreground-600">
                      <i className="ri-user-3-line" />
                      {c.target}
                    </span>
                  </div>
                  <h3 className="mt-3 text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {c.title}
                  </h3>
                  <p className="mt-2 max-w-3xl text-sm leading-7 text-foreground-600 line-clamp-2">{c.digest}</p>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-background-100 pt-3.5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line" /> {c.time}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-eye-line" /> {c.views} 浏览
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-chat-3-line" /> {c.reply} 讨论
                </span>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}